import React, {ComponentProps} from 'react'
import {
  LinkPreviewProviders,
  WixRicosViewer,
  pluginCodeBlockViewer,
  pluginEmojiViewer,
  pluginHashtagViewer,
  pluginIndentViewer,
  pluginLineSpacingViewer,
  pluginSpoilerViewer,
} from '@wix/ricos'
import {type RichContent} from '@wix/ricos'
import {
  pluginAudioLoadable,
  pluginCollapsibleListLoadable,
  pluginDividerLoadable,
  pluginFileUploadLoadable,
  pluginGalleryLoadable,
  pluginGiphyLoadable,
  pluginHtmlLoadable,
  pluginImageLoadable,
  pluginLinkLoadable,
  pluginLinkPreviewLoadable,
  pluginVideoLoadable,
} from '@wix/ricos/loadable'

import {APP_DEF_ID} from '../../../../utils/constants'

import '@wix/ricos/css/ricos-viewer.global.css'
import '@wix/ricos/css/plugin-hashtag-viewer.global.css'
import '@wix/ricos/css/plugin-spoiler-viewer.global.css'

export interface RicosViewerProps {
  content: RichContent
  msid: string
}

export const RicosViewer = React.memo(({content, msid}: RicosViewerProps) => {
  return (
    <WixRicosViewer
      msid={msid}
      content={content}
      plugins={plugins}
      theme={theme}
      biSettings={biSettings}
    />
  )
})

const plugins = [
  pluginAudioLoadable(),
  pluginCodeBlockViewer(),
  pluginCollapsibleListLoadable(),
  pluginDividerLoadable(),
  pluginEmojiViewer(),
  pluginFileUploadLoadable(),
  pluginGalleryLoadable(),
  pluginGiphyLoadable(),
  pluginHashtagViewer(),
  pluginHtmlLoadable(),
  pluginImageLoadable(),
  pluginIndentViewer(),
  pluginLineSpacingViewer(),
  pluginLinkLoadable(),
  pluginLinkPreviewLoadable({
    exposeEmbedButtons: [
      LinkPreviewProviders.Instagram,
      LinkPreviewProviders.Twitter,
      LinkPreviewProviders.TikTok,
    ],
  }),
  pluginSpoilerViewer(),
  pluginVideoLoadable(),
]

const theme: ComponentProps<typeof WixRicosViewer>['theme'] = {
  useWixStyles: true,
  typography: {
    fontFamily: 'var(--textAboutSectionFont-family)',
  },
  palette: {
    type: 'rgb',
    textColor: 'var(--textAboutSectionColor)',
  },
}

const biSettings: ComponentProps<typeof WixRicosViewer>['biSettings'] = {
  biCallbacks: {},
  consumer: 'Table Reservations',
  postId: '',
  containerId: APP_DEF_ID,
  platform: 'Livesite',
}
